import { matchPath } from 'react-router-dom';
import {
  ROUTE_CAMPAIGN_DETAILS_PAGE,
  ROUTE_DONATION_PAGE_LIST,
  ROUTE_ORGANIZER_CAMPAIGNS,
  ROUTE_PEER_TO_PEER_REGISTRATION,
  ROUTE_SIGNIN_PATH,
  ROUTE_START_GUIDE_ADVOCATE,
  ROUTE_START_GUIDE_CSR,
  ROUTE_START_GUIDE_EVERGREEN,
  ROUTE_START_GUIDE_ORGANIZATION,
  ROUTE_START_GUIDE_PERSONAL,
  ROUTE_START_GUIDE_PLUS_SUBSCRIPTION,
} from 'src/routes';

export const TOGGLER_SHOW_MAX_WIDTH = 1490; // in pixels. Taken from .visible-less-1490 in _site-common.scss

/**
 * true if left menu should be opened
 */
export const showLeftMenuOrNot = (pathname: string, innerWidth: number, overlayOpen: boolean): boolean => {
  /** if width is too small or there is campaign id in url, the menu must not be shown */
  if (innerWidth <= TOGGLER_SHOW_MAX_WIDTH || overlayOpen) {
    return false;
  }

  const lowerPathname = pathname.toLowerCase();

  /** closed */
  if (
    // setup pages always don't have menu opened
    ['/campaigns/setup', '/campaigns/donationpagesetup'].find((url) => lowerPathname.startsWith(url)) !== undefined ||
    [ROUTE_SIGNIN_PATH, ROUTE_PEER_TO_PEER_REGISTRATION].find((route) => matchPath(pathname, route)) ||
    pathname === '/'
  ) {
    return false;
  }

  /** opened */
  if (
    [
      '/campaigns/submit',
      '/campaigns/autoapprove',
      '/campaigns/publish',
      '/customertype',
      '/affiliatedashboard',
      '/evergreenorganizationsetup',
    ].find((url) => lowerPathname.startsWith(url)) !== undefined ||
    [
      ROUTE_START_GUIDE_ADVOCATE,
      ROUTE_START_GUIDE_ORGANIZATION,
      ROUTE_DONATION_PAGE_LIST,
      ROUTE_START_GUIDE_CSR,
      ROUTE_START_GUIDE_PERSONAL,
      ROUTE_START_GUIDE_EVERGREEN,
      ROUTE_START_GUIDE_PLUS_SUBSCRIPTION,
    ].find((route) => matchPath(pathname, route))
  ) {
    return true;
  }

  const fitsRoutesWithMenuClosed: boolean =
    [
      '/contributions',
      '/checkout',
      '/teammemberfullpage',
      '/me',
      '/teamfullpage',
      '/team',
      '/membercenter',
      '/home',
      '/organizationhomepage',
      '/startpage',
      '/registerorganizationpage',
      '/campaignpage',
      '/teammemberpage',
      '/teampage',
      '/payments/completepayment',
      '/administration',
      '/partner',
      '/paymentrecoverypage',
      '/account/profile/signup',
      '/account/profile/signuponboarding',
      '/donationpage',
      '/donpage',
      '/campaigns/',
      '/evergreenorganizationsetup',
      '/register',
    ].find((url) => lowerPathname.startsWith(url)) !== undefined;

  /**
   * routes on which the menu must be closed (true = closed)
   */
  let condition: boolean =
    fitsRoutesWithMenuClosed ||
    !!matchPath(pathname, ROUTE_CAMPAIGN_DETAILS_PAGE) ||
    !!matchPath(pathname, '/c/:id') ||
    !!matchPath(pathname, '/:id/m/:esheid/') ||
    !!matchPath(pathname, '/:id/t/:esheid/');
  /** get only campaign or donation public pages */
  if (
    !fitsRoutesWithMenuClosed &&
    (matchPath(pathname, { path: '/:id', exact: true }) ||
      matchPath(pathname, '/:id/campaign') ||
      matchPath(pathname, '/:id/teams') ||
      matchPath(pathname, '/:id/crowdfunding') ||
      matchPath(pathname, '/:id/event') ||
      matchPath(pathname, '/:id/sale') ||
      matchPath(pathname, '/:id/auction') ||
      matchPath(pathname, '/:id/pledge') ||
      matchPath(pathname, '/:id/members') ||
      matchPath(pathname, '/:id/sweepstakes') ||
      matchPath(pathname, '/:id/raffle'))
  ) {
    condition = true;
  }

  /** it's hard to calculate this route earlier */
  if (matchPath(pathname, ROUTE_ORGANIZER_CAMPAIGNS)) {
    condition = false;
  }

  return !condition;
};
